import React from 'react';
import { Shield } from 'lucide-react';

export const EligibilitySection = ({ formData, handleCheckboxChange }) => {
  const conditions = [
    {
      id: 'isAgeBetween21And80',
      title: 'Je confirme avoir plus de 21 ans et moins de 80 ans *',
      description: 'L\'assurance temporaire est réservée aux conducteurs âgés de 21 à 80 ans'
    },
    {
      id: 'hasMoreThan2YearsLicense',
      title: 'Je confirme avoir plus de 2 ans de permis de conduire *',
      description: 'Les conducteurs avec moins de 2 ans de permis ne peuvent pas souscrire'
    },
    {
      id: 'noAlcoholDrugRetention',
      title: "Je confirme n'avoir eu AUCUNE rétention de permis pour alcoolémie ou stupéfiants dans les 5 dernières années *",
      description: 'Toute rétention dans les 5 dernières années rend inéligible à cette assurance'
    },
    {
      id: 'notProfessionalOwner',
      title: "Je confirme que la carte grise N'EST PAS au nom d'un professionnel de l'automobile *",
      description: 'Concessionnaire, garagiste, marchand de véhicules : non éligible'
    },
    {
      id: 'notRentalVehicle',
      title: "Je confirme que le véhicule N'EST PAS une location par un professionnel de l'automobile ou une agence de location *",
      description: 'Véhicules de location (agence, professionnel) : non éligible'
    }
  ];

  return (
    <div className="border-l-4 border-red-600 pl-6 bg-red-50 p-6 rounded-r-lg">
      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Shield size={24} className="text-red-700" />
        Conditions d'Éligibilité - IMPORTANT
      </h3>
      <p className="text-sm text-red-700 font-semibold mb-4">
        Vous devez confirmer toutes les conditions suivantes pour pouvoir souscrire :
      </p>
      
      <div className="space-y-4">
        {conditions.map((condition) => (
          <div key={condition.id} className="flex items-start gap-3 bg-white p-4 rounded-lg border border-red-200">
            <input
              type="checkbox"
              id={condition.id}
              name={condition.id}
              checked={formData[condition.id]}
              onChange={handleCheckboxChange}
              required
              className="mt-1 h-5 w-5 text-blue-700 focus:ring-blue-600"
            />
            <label htmlFor={condition.id} className="text-gray-900 cursor-pointer">
              <span className="font-semibold">{condition.title}</span>
              <p className="text-sm text-gray-600 mt-1">{condition.description}</p>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
